app.filter('timeSince', function (dateFilter, $interval) {
    return function (date) {
        const now = Date.now();
        const start = +new Date(date);
        const duration = now - start;

        const d = new Date("1-1-1970 00:00:00");
        d.setSeconds(duration / 1000);
        return dateFilter(d, 'HH:mm:ss');
    };
});
